<template>
  <div
    class="wrapperx bg-image"
  >
    <div class="yet-another-wrapper">
      <div class="full-area vertically-centered bg-image qr-page">
        <div class="camera-controller">
          <div class="controls-wrapper">
            <div class="not-allowed-block" v-if="notAllowed">
              <div @click="showBlockedCameraMessage()">
                <Icons
                  class="icon delay-entry"
                  icon="video-off"
                  size="60"
                  :color="'rgba(93,36,102,0.9)'"
                ></Icons>
              </div>
            </div>
            <div class="not-allowed-block" v-if="notReadableError || notAllowed">
              <div @click="reloadApp()">
                <Icons
                  class="icon delay-entry"
                  icon="reload"
                  size="60"
                  :color="'rgba(93,36,102,0.9)'"
                ></Icons>
              </div>
            </div>
          </div>
        </div>

        <div class="qr-camera-wrapper">
          <transition name="fade">
            <div class="instructions qr-content" v-if="!decoded">
              <Icons
                class="icon qr-code-icon shakeIt"
                icon="qr-code"
                size="200"
                :color="'rgba(255,255,255,0.2)'"
              ></Icons>
            </div>
          </transition>            
          <qrcode-stream @decode="onDecode" :key="randomKey" @init="onCameraChange" v-if="cameraIsNeeded">
          </qrcode-stream>
        </div>

        <div class="extra-overlay" :class="{'active': startTransition}">
        </div>

        <div class="feedback-wrapper">
          <transition name="slide" mode="out-in">
            <div class="" v-if="decoded && validAlias === -1">
              <Icons class="icon shakeIt" icon="alert" size="160" :color="'rgba(93,36,102,0.95)'"></Icons>
            </div>
          </transition>
          <transition name="slide" mode="out-in">
            <div class="" v-if="decoded && validAlias === 1">
              <Icons class="icon shakeIt" icon="check" size="160" :color="'rgba(93,36,102,0.95)'"></Icons>
            </div>
          </transition>
        </div>
      </div>

      <vue-markdown class="html-content" v-if="data.fields.text">{{data.fields.text}}</vue-markdown>

      <div class="response-area" :class="{active: responseActive}">
        <div v-if="decoded">
          <div class="decoded-input">
            {{selected}}
          </div>
          <el-button
            type="danger"
            @click="submit()"
            class="submit-button"
          >Siguiente</el-button>
        </div>
        <div v-if="!decoded">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :lg="24" class="column first-column">
              <div class="text">
                ¿No tienes un código QR pero ya estás registrado?
              </div>
              <el-button
                type="success"
                @click="login()"
                class="submit-button"
              >Ingresa tus datos</el-button>              
            </el-col>
            <el-col :xs="24" :sm="12" :lg="24" class="column last-column">
              <div class="text">
                ¿No tienes cuenta aún? ¡Regístrate en 30 segundos!
              </div>
              <div>
                <el-button
                  type="danger"
                  @click="register()"
                  class="submit-button"
                >Regístrate</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import VueMarkdown from 'vue-markdown'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default {
  name: 'QRReader',

  transition: 'page',

  props: [ 'data' ],

  components: {
    VueMarkdown,
    Icons: () => import('Components/base/Icons'),
    QrcodeStream
  },

  data () {
    return {
      cameraError: '',
      canForward: false,
      cameraAvailable: true,
      notAllowed: false,
      notReadableError: false,
      copyText: 'Copy!',
      randomKey: Math.random(),
      qrInput: null,
      url: null,
      decoded: false,
      selected: '',
      validAlias: 0,
      startTransition: false,
      cameraIsNeeded: true,
      disableSubmitButton: true,
      nickname: null,
      timer: null,
      responseActive: false,
      form: {
        decoded: false,
        question: this.data.fields.name,
        id: this.data.sys.id,
        selected: null,
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      }
    }
  },

  computed: {
    routeName () {
      return this.$route.name
    }
  },

  mounted () {
    this.timer = setTimeout(() => {
      this.responseActive = true
    }, 5000)
  },

  methods: {
    mdToHTML (markdown) {
      return documentToHtmlString(markdown)
    },
    reloadApp () {
      window.location.reload()
    },
    showBlockedCameraMessage () {
      this.$alert('Para poder usarla, autorizala en la barra de navegación, o autorízala en las propiedades de este sitio, y luego reinicia la aplicación o recarga la página.', 'Cámara Bloqueada', {
        confirmButtonText: 'OK'
      })
    },
    onCameraChange (promise) {
      promise.catch(error => {
        const cameraMissingError = error.name === 'OverconstrainedError'
        const notAllowedError = error.name === 'NotAllowedError'

        if (error.name === 'OverconstrainedError') {
          this.cameraAvailable = false
          return
        }
        if (error.name === 'NotAllowedError') {
          this.cameraAvailable = false
          this.notAllowed = true
          return
        }
        if (error.name === 'NotReadableError') {
          this.notReadableError = true
        }
        this.cameraError = error.name
        this.cameraAvailable = false

      })
    },
    onDecode ($event) {
      this.qrInput = $event
      this.selected = this.qrInput
      this.decoded = true
      this.responseActive = true
      setTimeout(() => {
        this.next()
      }, 1500)
    },
    login () {
      this.$emit('login')
    },
    register () {
      this.$emit('register')
    },
    submit () {
      if (this.validInput(this.qrInput)) {
        this.form.selected = [this.qrInput]
        this.next()
      }
    },
    next () {
      this.arrows = false
      this.form.timestamps.finish = new Date()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value && value.length >= 5) {
        this.form.timestamps.valid = new Date()
        this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal[0])) {
        setTimeout(() => {
          this.next()
        }, 50)
      }
    },
    'qrInput': function (newVal, oldVal) {
      if (this.validInput(newVal)) {
        this.disableSubmitButton = false
      } else {
        this.disableSubmitButton = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
.decoded-input {
  min-height: 3em;
  margin-top: 5vh;
  font-size: 1.2em;
  @include breakpoint($tablet) {
    font-size: 1em;
  }
  @include breakpoint($desktop) {
    font-size: 0.9em;
  }
}
.text {
  font-size: 1.2em;
  margin-top: 1.5em;
  padding: 0 1em;
  @include breakpoint($tablet) {
    font-size: 1em;
    min-height: 3em;
  }
  @include breakpoint($desktop) {
    font-size: 0.7em;
  }
}
.column {
  &.last-column {
    border-left: 1px solid $gray-light;
  }
}
.response-area {
  position: fixed;
  bottom: 0;
  top: 45vh;
  right: 0;
  left: 0;
  z-index: 1000;
  background: rgba(white, 0.99);
  opacity: 0.0001;
  transition: all 0.2s ease-in-out;
  &.active {
    opacity: 1;
  }
}
.html-content {
  position: fixed;
  top: 50vh;
  bottom: 0;
  left: 0;
  right: 0;
}
.feedback-wrapper {
  color: $text-main;
  text-align: center;
  width: 100%;
  height: 100%;
  margin-top: 60vh;
  position: absolute;
  z-index: 0;
  @include breakpoint($desktop) {
    transform: translateY(10vh);
  }
  @include breakpoint($fullhd) {
    transform: translateY(-1vh);
  }
}
.number-input-wrapper {
  background: white;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  color: white;
  flex-direction: row;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-top: 0.5em;
  align-items: flex-start;
  position: absolute;
  width: calc(100% - 1em);
  top: 0;
  margin-top: 75%;
  height: 100%;

  @include breakpoint($tablet) {
    background-color: #fcfcef;
  }
  @include breakpoint($desktop) {
    transform: translateY(12vh);
  }
}
.number-input {
  width: 100%;
  display: flex;
  height: 2.5em;
  font-size: 30px;
  input {
    color: $color-wrapper-emphasis;
    font-family: monospace;
    margin: 0 5px;
    text-align: center;
    line-height: 50px;
    font-size: 30px;
    border: solid 1px #ccc;
    box-shadow: 0 0 5px #ccc inset;
    outline: none;
    width: 100%;
    height: 100%;
    transition: all .2s ease-in-out;
    border-radius: 3px;
    
    &:focus {
      border-color: purple;
      box-shadow: 0 0 5px purple inset;
    }
    
    &::selection {
      background: transparent;
    }
  }
  @include breakpoint($tablet) {
    height: 2em;
    font-size: 50px;
    input {
      font-size: 50px;
    }
  }
}
.camera-controller {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 0;
  padding-bottom: 75%;
  position: absolute;
  top: 0;
  transform: translateY(5vh);
  z-index: 100;
  position: absolute;
  @include breakpoint($desktop) {
    transform: translateY(16vh);
  }
}
.controls-wrapper {
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  height: 100%;
}
.not-allowed-block {
  z-index: 100;
  margin-top: 20%;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.decoded-no-url {
  position: absolute;
  margin-top: -10000px;
}
.scan-wrapper {
  height: 100vh;
  width: 100vw;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 0;
  @include breakpoint($tablet) {
    background-color: #fcfcef;
  }
  @include breakpoint($desktop) {
    background-size: 40%;
    background-position: -15% 105%;
  }
}
.decoded-content {
  display: inline;
  overflow-wrap: break-word;
}
.qr-input-field {
  max-width: 95%;
}
.column-content {
  display: flex;
  flex-direction: column;
  margin: auto;
  line-height: 1;
  margin-top: 0.5em;
}
.extra-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  transition: all 0.2s ease-in-out;
  background-color: white;
  opacity: 0.0001;
  z-index: -1;
  &.active {
    z-index: 100;
    opacity: 1;
  }
}
.full-area {
  overflow: hidden;
  position: relative;
  max-height: 100vh;
  height: 100vh;
  background: transparent !important;

  @include breakpoint($tablet) {
    max-width: 500px;
    margin: auto;
  }

  .overlay {
    opacity: 1;
    z-index: 20;
    position: absolute;
    height: 100vh;
    width: 100vw;
    transition: all 0.2s ease-in-out;
    @include breakpoint($desktop) {
      transform: translateY(12vh);
    }

    &.hidden {
      background: transparent;
      z-index: -1;
    }
  }
}
.protocol {
  color: rgba(white, 0.3);
}

.qr-camera-wrapper {
  position: absolute;
  overflow: hidden;
  z-index: 1;
  top: 0;
  width: 100%;
  height: 0;
  padding-bottom: 75%;
  @include breakpoint($desktop) {
    transform: translateY(12vh);
  }
}
.qr-content {
  position: absolute;
  height: 100%;
  width: 0;
  padding-bottom: 75%;
  color: rgba(255, 255, 255, 0.8);
  display: flex;

  width: 100%;
  z-index: 1000;
  justify-content: center;
  align-items: center;
  @include breakpoint($desktop) {
    font-size: 0.8em;
  }
}

.submit-button {
  transform: scale(1.3);
  display: inline;
  max-width: 45%;
  margin: auto;
  margin-top: 2em;
  min-width: 100px;
}
.instructions {
  background: rgba(#100014, 0.2);
}

.shakeIt {
  animation: shakeItMore 1.22s ease-in-out infinite forwards;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  animation-delay: 1.2s;
}

@keyframes shakeItMore {
  0% { transform: rotate(0deg) scale(1); opacity: 0.9;}
  20% { transform: rotate(-0deg) scale(1.01); opacity: 1; }
  40% { transform: rotate(-0deg) scale(1); opacity: 0.9; }
  100% { transform: rotate(-0deg) scale(1); opacity: 0.9; }
}

.qr-camera-wrapper {
  .wrapper {
    padding: 0 !important;
    background: none !important;
  }
}

</style>
<style lang="scss">
.qr-camera-wrapper {
  .wrapper {
    padding: 0 !important;
    background: none !important;
  }
}
.el-button--primary {
  border-color: $color-wrapper-emphasis !important;
  background-color: $color-wrapper-emphasis !important;
}
.qr-input-field {
  .el-textarea {
    font-size: 2em;
    font-family: monospace;
    margin-bottom: 0.5em;
  }
  .el-textarea__inner:focus {
    border-color: rgba($gray-medium, 0.4);
  }
  .el-input__inner {
    border: 1px solid $color-emphasis;
    text-align: center !important;
    font-size: 2em;
    padding: 1em;
    font-family: monospace;
  }
  .el-input__inner:focus {
    border-color: rgba($gray-medium, 0.4);
  }
}

</style>
<style lang="scss">
.qr-input-field {
  .el-textarea {
    font-size: 2em;
    font-family: monospace;
    margin-bottom: 0.5em;
  }
  .el-textarea__inner:focus {
    border-color: rgba($gray-medium, 0.4);
  }
  .el-input__inner {
    border: 1px solid $color-emphasis;
    text-align: center !important;
    font-size: 2em;
    padding: 1em;
    font-family: monospace;
  }
  .el-input__inner:focus {
    border-color: rgba($gray-medium, 0.4);
  }
}

</style>
